module.exports = Jsw.skinUrl + "/images/disco-mode/logo.svg?04088e600aa6f5cc98a76ab738d33304";